import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeKatex from "rehype-katex";
import remarkGfm from "remark-gfm";
import styles from "./SummaryViewer.module.scss";
import { useEffect } from "react";
import { useState } from "react";

interface SummaryViewerProps {
  summaryView: {viewed: boolean, doc: string, summary: string};
  setSummaryView: (summaryView: {viewed: boolean, doc: string, summary: string}) => void;
}

const SummaryViewer = ({summaryView, setSummaryView}: SummaryViewerProps) => {

  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    setShowMessage(true);
    // Set a timer to hide the message after 3 seconds
    const timer = setTimeout(() => {
      setShowMessage(false);
    }, 10000);
    // Cleanup function to clear the timer if the component unmounts
    return () => clearTimeout(timer);
  }, [summaryView.doc]);

  return (
    <div style={{paddingLeft: "30px", paddingRight: "30px"}}>
      <h3 style={{color: "#333"}}>{summaryView.doc} TEST</h3>
      {showMessage && <div style={{color: "green", fontWeight: "bold"}}>Info: You are now chatting with this document.</div>}
        <div className={styles.summaryContainer}>
          <ReactMarkdown
            className={styles.markdown}
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw, rehypeKatex]}
          >
            {summaryView.summary}
          </ReactMarkdown>
        </div>
    </div>
  );
};

export default SummaryViewer;
